import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { exchangeSession, useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const target = location.pathname + location.search;
    if (!sessionId) {
      navigate(target, { replace: true });
      return;
    }
    exchangeSession(sessionId)
      .then((user) => {
        setUser(user);
        toast.success(`Signed in as ${user.name || user.email}`);
        navigate(target, { replace: true, state: { user } });
      })
      .catch(() => {
        setFailed(true);
        toast.error("Sign-in failed. Please try again.");
        navigate(target, { replace: true });
      });
  }, [location, navigate, setUser]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex items-center justify-center bg-white"
    >
      <div className="font-mono-label text-[11px] tracking-[0.2em] uppercase text-[#5F6168] flex items-center gap-3">
        <span className="live-dot" aria-hidden />
        {failed ? "Sign-in failed" : "Signing you in"}
      </div>
    </div>
  );
}
